const getErrStatusList = (allowedErrStatus?: number | number[]): number[] => {
  if (!allowedErrStatus) {
    return [];
  }
  return Array.isArray(allowedErrStatus) ? allowedErrStatus : [allowedErrStatus];
};
export default getErrStatusList;
